import {
  Component,
  EventEmitter,
  forwardRef,
  Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {PopupServices} from "../../../services/popup.services";
import {Router} from "@angular/router";
import {SessionService} from "../../../services/session.service";
import {TranslateService} from "@ngx-translate/core";
import {Utils} from "../../../model/Utils";
import {MyTreeHelper} from "./helpers/MyTreeHelper";
import {TreeviewItem, TreeviewSelection} from "./models/treeview-item";

@Component({
  selector: 'dropdownTree',
  templateUrl: './DropdownTreeComponent.html',
  styleUrls: ['./DropdownTreeComponent.scss'],
  /*providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownTreeComponent),
      multi: true
    }
  ]

   */
})

export class DropdownTreeComponent implements /*ControlValueAccessor,*/ OnChanges {

  @Input() buttonClass = 'btn-outline-secondary';

  @Output()
  selectedChange = new EventEmitter<any[]>();

  @Input()
  selectLabelCode: string;

  @Input()
  itemSelectedLabelCode: string;


  // @ViewChild(TreeComponent, { static: false }) treeviewComponent: TreeComponent;
  //@ViewChild(TreeComponent) treeviewComponent: TreeComponent;

  /*
  public disabled = false;
  private _onTouchedCallback: any = () => {
  };
  private _onChangedCallback: any = () => {
  };

   */

  @Input()
  public items = new Array<TreeviewItem>();

  selection: TreeviewSelection;

  // private  allItem: TreeviewItem; // I don't what is this thing for.

  constructor(
    @Inject(forwardRef(() => DomSanitizer)) private domSanitizer: DomSanitizer,
    @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
    @Inject(forwardRef(() => PopupServices)) private popupServices: PopupServices,
    @Inject(forwardRef(() => Router)) private router: Router,
    @Inject(forwardRef(() => SessionService)) private session: SessionService,
    @Inject(forwardRef(() => TranslateService)) private translateService: TranslateService
  ) {

  }

  public get hasFilterItems() {
    if (this.items) {
      if (this.items.length > 0) {
        return true;
      }
    }
    return false;
  }

  /*
  writeValue(obj: any): void {
    // console.log('WriteValues ',obj)
    if (!obj) {
      return;
    }
    this.items = obj;
    // this._selectedIds = obj;
    // this._resetSelectableModel();
  }

  registerOnChange(fn: any): void {
    this._onChangedCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouchedCallback = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

   */


  ngOnChanges(changes: SimpleChanges): void {
    // console.log('OnChanges: ', changes);
    //this._resetSelectableModel();
  }

  get label(){

    let checkedItems: TreeviewItem[] = [];
    let uncheckedItems: TreeviewItem[] = [];
    if (!Utils.isNullOrUndefined(this.items)) {
      const selection = MyTreeHelper.concatSelection(this.items, checkedItems, uncheckedItems);
      // checkedItems = selection.checked;
      // uncheckedItems = selection.unchecked;
      checkedItems = selection['checked'];
      uncheckedItems = selection['unchecked'];
    }
    switch (checkedItems.length) {
      case 0:
        return this.translateService.instant(this.selectLabelCode);
      case 1:
        return checkedItems[0].text;
      default:
        return this.translateService.instant(this.itemSelectedLabelCode,{nbOptions:checkedItems.length});
    }
  }

  onSelectedChange(values: any[]): void {
    //this.buttonLabel = this.i18n.getText(this.treeviewComponent.selection);
    this.selectedChange.emit(values);

  }

  /*
  getText(selection: TreeviewSelection): string {
    if (selection.uncheckedItems.length === 0) {
      if (selection.checkedItems.length > 0) {
        return this.getAllCheckboxText();
      } else {
        return '';
      }
    }

    switch (selection.checkedItems.length) {
      case 0:
        return 'Select options';
      case 1:
        return selection.checkedItems[0].text;
      default:
        return `${selection.checkedItems.length} options selected`;
    }
  }

   */

}
